require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.slice");

require("core-js/modules/web.dom-collections.for-each");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "vant/es/toast/style", "vant/es/toast"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("vant/es/toast/style"), require("vant/es/toast"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.style, global.toast);
    global.deviceTestList = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _style, _toast) {
  "use strict";

  var _interopRequireDefault = require("/root/deploy/iot-product-tool/node_modules/@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _toast = _interopRequireDefault(_toast);
  var _default = {
    name: 'XiazengDeviceTestList',
    data: function data() {
      var ossHostPond = this.$config.base.ossHostPond;
      return {
        ossPondHost: ossHostPond,
        list: []
      };
    },
    created: function created() {
      this.loadList();
    },
    methods: {
      // 编号只展示后六位, 前面加...; 空值原样返回
      maskLastSix: function maskLastSix(num) {
        return num && num.length > 6 ? '...' + num.slice(-6) : num || '';
      },
      // 获取设备列表(零件检测-待检测设备列表)
      loadList: function loadList() {
        var vm = this;

        var toast = _toast.default.loading({
          message: '加载中',
          forbidClick: true,
          duration: 0
        });

        vm.$http({
          method: 'GET',
          url: vm.$config.base.XIAZENG_BASE_URL + 'xia/factory/parts/devices'
        }).then(function (res) {
          toast.clear(); // 接口返回 data 直接为设备数组

          var devices = res.data || [];
          var list = Array.isArray(devices) ? devices : [];
          list.forEach(function (item) {
            var ps = item.processState || {}; // 展示编号: 有正式编号优先展示, 否则展示 imei/iccid 后六位

            item.displayNum = ps.serverUniqueId || vm.maskLastSix(item.imei || item.iccid);
          });
          vm.list = list;
        }).catch(function () {
          toast.clear();
        });
      },
      // 点击刷新按钮
      onclickRefreshBtn: function onclickRefreshBtn() {
        this.loadList();
      },
      // 点击测试 - 跳转测试详情
      onclickTestBtn: function onclickTestBtn(index) {
        sessionStorage.setItem('xiazengDeviceTestList', JSON.stringify(this.list));
        this.$router.push({
          path: './deviceTestDetail',
          query: {
            index: index
          }
        });
      }
    }
  };
  _exports.default = _default;
});